(function () {
    'use strict';

    angular.module("imApp").factory("stockGetService", ['$ihttp', function ($ihttp) {
        let service = {
            getStock: function (parms) {
                return $ihttp.post({
                    method: 169,
                    parameters: parms || {}
                });
            },
            listProdBeoMethods: function (parms) {
                return $ihttp.post({
                    method: 997,
                    parameters: parms || {}
                });
            },
            listOwnKpis: function (parms) {
                return $ihttp.post({
                    method: 3338,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 473,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
